__turbopack_context__.v({
  "emailOptinFormContainer": "EmailOptInForm-module__R16Q9W__emailOptinFormContainer",
});
